<div class="main-content">
    <ng-container *ngIf="!errorGettingPageImg; else errorMessage">
        <div class="toolbar row align-items-center"
             #toolbarRef
             [class.toolbar-narrow]="toolbarIsNarrow"
             [class.toolbar-very-narrow]="toolbarIsVeryNarrow">
            <div class="col-12 col-xl-3" *ngIf="!showTable && !showJson">
                <app-pdf-search
                  [searchText]="searchText"
                  [searchPerformed]="searchPerformed"
                  [searchLoading]="searchLoading"
                  [currentMatchNumber]="currentMatchNumber"
                  [totalMatches]="totalMatches"
                  [disabled]="!documentFileId"
                  [searchError]="searchError"
                  (searchTextChange)="onSearchTextChange($event)"
                  (searchSubmit)="onSearchSubmit()"
                  (goToPrevious)="goToPreviousMatch()"
                  (goToNext)="goToNextMatch()"
                  (clearSearch)="clearSearch()"
                ></app-pdf-search>
            </div>
            <div class="col-12 col-xl-9 toolbar-row-flex">
                <div class="centered-content">
                    <app-pdf-paginator [pageCount]="pageCount"></app-pdf-paginator>
                    <div class="btn-separator">|</div>
                    <app-pdf-zoom [zoomElementContainerId]="showTable ? 'page-table-list' : (showJson ? 'page-json-list' : 'page-img-list')"></app-pdf-zoom>
                </div>
                <div class="right-aligned-content">
                    <button class="btn btn-empty-primary close-button" (click)="exitSplitscreen()"
                            [title]="closeButtonTooltip">
                        <i class="fas fa-xmark"></i>Close
                    </button>
                </div>
            </div>
        </div>
        <div class="row doc-container px-0 fs-block" #docContainer (scroll)="handleScroll()">
            <div *ngIf="!showTable && !showJson">
                <div id="page-img-list" class="page-images"
                     appImgIntersectionObxList [forceChangeDetection]="true"
                >
                    <div class="page-img-list-item index-{{i}}"
                        [attr.id]="'index-'+i"
                        #pageImgListItem
                        appImgIntersectionObx
                        #intersection="intersection"
                        *ngFor="let pageUrl of pageImgUrls; let i = index;">
                        <app-image-highlighter
                            *ngIf="intersection.hasIntersected || activeHighlightPageIndex === i; else imagePlaceholder"
                            [cropper]="i===viewSourcePage ? cropper: null"
                            [pageImgUrl]="pageUrl"
                            [imagePlaceholderHeight]="imgPlaceholderHeight"
                            [highlights]="getHighlightsForPage(i)"
                            [activeHighlightId]="activeHighlightId"
                            (rerenderEvent)="rerenderEvent.emit()"
                            (highlightsRendered)="onHighlightsRendered()"
                        ></app-image-highlighter>
                        <ng-template #imagePlaceholder>
                            <div class="image-placeholder"
                                 [ngStyle]="{'height.px': imgPlaceholderHeight}">
                                ...
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div *ngIf="showTable">
                <div id="page-table-list">
                    <table class="excel-table fs-block" *ngFor="let page of documentPages" #pageImgListItem>
                        <tr *ngFor='let row of page.cells'>
                            <td *ngFor='let col of row'>{{ col.text }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div *ngIf="showJson" id="page-json-list" class="json-source-wrap">
                <p *ngIf="jsonLoading" class="json-source-loading mb-0">Loading source JSON…</p>
                <pre *ngIf="!jsonLoading && jsonFormatted" class="json-source-preview">{{ jsonFormatted }}</pre>
                <p *ngIf="!jsonLoading && !jsonFormatted && originalFileUrl" class="text-muted small mb-0">
                    No content returned. Use Download if the file is available.
                </p>
            </div>
        </div>
    </ng-container>
    <ng-template #errorMessage>
        <div class="error-message">
            <h5 class="mb-5">Error retrieving original document for display.
                <span *ngIf="originalFileUrl">Try downloading the document directly.</span>
            </h5>
            <a *ngIf="originalFileUrl" class="btn btn-empty-primary" target="_blank"
               href="{{originalFileUrl}}">
                <i class="fas fa-download"></i> Download Document
            </a>
        </div>
    </ng-template>
</div>
<div *ngIf="showLoadingOverlay" class="loading-overlay">
    <div class="loader"></div>
</div>
